import PushPin from "@mui/icons-material/PushPin";
import UnpinnedIcon from "@mui/icons-material/PushPinOutlined";
import type { SvgIconProps } from "@mui/material";
import { styled } from "@mui/material";

export interface ThumbtackIconProps {
  pinned?: boolean;
}

const PinnedIcon = styled(PushPin)(({ theme }) => ({
  color: theme.palette.grey[800],
}));

export const ThumbtackIcon = ({
  pinned,
  ...props
}: SvgIconProps & ThumbtackIconProps) =>
  pinned ? <PinnedIcon {...props} /> : <UnpinnedIcon {...props} />;

export default ThumbtackIcon;
